import type { useGetPartnerAdminsUser } from '~/hooks';
import type { EditUserFormBankAccountPresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof EditUserFormBankAccountPresentation>;

type Args = {
  data: ReturnType<typeof useGetPartnerAdminsUser>['data'];
};

type IConvertToPresentationProps = (
  args: Args
) => Pick<PresentationProps, 'isBillableFromEditable'>;

/**
 * API レスポンスの利用者データを Presentation Props に変換する
 *
 * @param data - GET /partner_admins/users/:userId のレスポンス
 * @returns isBillableFromEditable - 利用開始日の編集可否フラグ
 */
export const convertToPresentationProps: IConvertToPresentationProps = ({ data }) => ({
  isBillableFromEditable: data.user.is_billable_from_editable,
});
